import type { Role } from '@/types/user'

export const ROLE_HOME: Record<Role, string> = {
  admin: '/admin',
  supplier: '/supplier',
  client: '/client',
}

/**
 * Landing path for a user after authentication. A user with no assigned role
 * (no `role` custom claim) is sent to `/login`, where a notice is shown.
 */
export function roleHome(role: Role | null): string {
  return role ? ROLE_HOME[role] : '/login'
}
